<template>
  <div class="estado-vacio text-center py-8 px-4">
    <v-icon :color="colorIcono" size="56" class="mb-3">{{ icono }}</v-icon>

    <div class="estado-vacio-titulo mb-1">{{ titulo }}</div>

    <div v-if="descripcion" class="estado-vacio-descripcion mb-4">
      {{ descripcion }}
    </div>

    <div class="d-flex justify-center flex-wrap" style="gap: 8px">
      <slot name="accion"></slot>
    </div>
  </div>
</template>

<script>
/**
 * Estado vacío ilustrado: ícono + título + explicación + salida.
 *
 * Existe porque el vacío por defecto de la tabla es un string plano en
 * `no-data-text`, que no permite ofrecerle al usuario una salida ("quitar
 * filtros", "reintentar"). Un listado vacío sin explicación deja al usuario sin
 * saber si no hay datos, si el filtro los escondió o si la carga falló.
 */
export default {
  name: 'BaseEstadoVacio',

  props: {
    icono: { type: String, default: 'mdi-database-search-outline' },
    titulo: { type: String, default: 'No hay información para mostrar' },
    descripcion: { type: String, default: '' },
    colorIcono: { type: String, default: 'neutral-400' },
  },
};
</script>

<style scoped>
.estado-vacio-titulo {
  color: var(--v-neutral-800-base);
  font-size: 1rem;
  font-weight: 600;
}

.estado-vacio-descripcion {
  color: var(--v-neutral-600-base);
  font-size: 0.85rem;
  line-height: 1.5;
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
  /* La tabla fuerza mayúsculas en algunas celdas; acá el texto explicativo se lee
     en su capitalización natural porque son frases, no etiquetas. */
  text-transform: none;
}
</style>
